const declareRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/purchaser', // 采购商健康申报
      name: 'Purchaser',
      meta: { title: '采购商健康申报' },
      component: () => import(/* webpackChunkName: "declare" */ '@/pages/welcomeToYiwu/purchaser')
    },
    {
      path: '/convention', // 会展参展商申报
      name: 'Convention',
      meta: { title: '会展参展商申报' },
      component: () => import(/* webpackChunkName: "declare" */ '@/pages/welcomeToYiwu/convention')
    }
  ]
}

export default declareRouter
